import { Storage } from '@ionic/storage'

let localStorage

// Writes are chained so reads wait for them. Without this, on a brand-new
// browser (IndexedDB not opened yet) a read issued right after an unawaited
// write is ordered ahead of it and returns null - e.g. the first authenticated
// request after login goes out with no token and gets a 401.
let pendingWrites = Promise.resolve()

function queueWrite(write) {
  const result = pendingWrites.then(write)
  pendingWrites = result.catch(() => {})
  return result
}

export async function initializeStorage() {
  localStorage = new Storage()
  await localStorage.create()

  return localStorage
}

export function storageSet(key, val) {
  return queueWrite(() => localStorage.set(key, val))
}

export async function storageGet(key) {
  await pendingWrites
  const val = await localStorage.get(key)
  return val
}

export async function storageRemove(key) {
  await queueWrite(() => localStorage.remove(key))
}
